import { styled } from '@mui/material'
import { FC, memo, useEffect, useState } from 'react'
import { Flex, FlexCenter, FlexColumn } from '../../../styles'
import { Balances } from '../Balances'
import { CreateOrder } from '../CreateOrder'
import { SpotRecentTrades } from '../Trade'
import { MobileCharting } from './MobileCharting'
import { MobileOrderBook } from './MobileOrderBook'
import { useAppDispatch } from 'store'
import { updateCurrentChartTab } from 'store/orderbook/actions'
import { TradingViewKLintType } from 'store/orderbook/reducer'

const list = [
  { name: 'ZKEX', id: 0 },
  { name: 'Binance', id: 1 },
  { name: 'Order Book', id: 2 },
  { name: 'Recent Trades', id: 3 },
  { name: 'Assets', id: 4 },
]
const MobileWrap = styled(FlexColumn)`
  ${(props) => props.theme.breakpoints.down('md')} {
    flex: unset;
  }
`
const MobileTab = styled(Flex)`
  width: 100%;
  height: 40px;
  padding: 0 8px;
  background: ${(props) => props.theme.color.bgGray};
  border-top: 1px solid ${(props) => props.theme.color.text20};
  border-bottom: 1px solid ${(props) => props.theme.color.text20};
`
const MobileTabItem = styled(FlexCenter)`
  height: 100%;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  padding: 0 8px;
  color: rgba(149, 164, 173, 1);

  &.active {
    color: rgba(160, 238, 9, 1);
  }
  &:last-child {
    border: none;
  }
`

const MobileContent = styled(Flex)`
  // height: 40vh;
`
const HiddenBalance = styled(Flex)`
  position: fixed;
  left: 9999px;
`

const MobileBalanceWrap = styled('div')`
  padding-bottom: 12px;
  width: 100%;
  > div {
    border: none;
  }
`

const FullWidthWrap = styled('div')`
  width: 100%;
`

export const MobileOrderBookContent: FC = memo(() => {
  const dispatch = useAppDispatch()
  const [tabIndex, setTabIndex] = useState<number>(0)

  useEffect(() => {
    if (tabIndex === 0) {
      dispatch(updateCurrentChartTab(TradingViewKLintType.ZKEX))
    } else if (tabIndex === 1) {
      dispatch(updateCurrentChartTab(TradingViewKLintType.BINANCE))
    }
  }, [tabIndex])

  return (
    <MobileWrap>
      <MobileTab>
        {list.map((item, index) => {
          return (
            <MobileTabItem
              onClick={() => setTabIndex(item?.id)}
              key={index}
              className={tabIndex === item?.id ? 'active' : ''}
            >
              {item.name}
            </MobileTabItem>
          )
        })}
      </MobileTab>
      <MobileContent>
        {(tabIndex === 0 || tabIndex === 1) && <MobileCharting />}
        {tabIndex === 2 && <MobileOrderBook />}
        {tabIndex === 3 && (
          <FullWidthWrap>
            <SpotRecentTrades />
          </FullWidthWrap>
        )}
        {tabIndex === 4 && (
          <MobileBalanceWrap>
            <Balances />
          </MobileBalanceWrap>
        )}
      </MobileContent>
      <HiddenBalance>
        <Balances />
      </HiddenBalance>
      <CreateOrder />
    </MobileWrap>
  )
})
